import script from "./Top.vue?vue&type=script&setup=true&lang=ts"
export * from "./Top.vue?vue&type=script&setup=true&lang=ts"

import "./Top.vue?vue&type=style&index=0&id=5a39478b&lang=scss&scoped=true"

import exportComponent from "/Users/123imac-49/Desktop/123-chat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a39478b"]])

export default __exports__